import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles, tokens } from '@fluentui/react-components';

const PREVIEW_KEY = 'fitit_preview_auth';
const PREVIEW_USER = 'admin';
const PREVIEW_PASS = 'admin987';

export function usePreviewAuth() {
  return localStorage.getItem(PREVIEW_KEY) === '1';
}

// Šis prieigos "vartų" ekranas sąmoningai atskirtas nuo likusio programos dizaino
// (tamsi gradiento fonas, stiklo efekto prisijungimo kortelė, savas prekės ženklo
// akcentas) — dekoratyvios spalvos/šešėliai neturi Fluent token atitikmens, tad
// lieka literalios CSS reikšmės; tarpai, šriftų dydžiai ir apvalinimai naudoja
// tokens.* ten, kur reikšmė sutampa tiksliai.
const useStyles = makeStyles({
  page: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 50%, #16213e 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    padding: '24px',
  },
  wrap: { width: '100%', maxWidth: '440px', textAlign: 'center' },
  logo: { marginBottom: '48px' },
  title: {
    fontSize: '38px', fontWeight: 800, color: '#ffffff',
    letterSpacing: '-0.02em', margin: `0 0 ${tokens.spacingVerticalS}`,
  },
  subtitle: {
    fontSize: tokens.fontSizeBase300, color: 'rgba(255,255,255,0.5)', margin: 0,
    letterSpacing: '0.12em', textTransform: 'uppercase',
  },
  card: {
    background: 'rgba(255,255,255,0.05)',
    border: '1px solid rgba(255,255,255,0.1)',
    borderRadius: '20px',
    padding: `${tokens.spacingVerticalXXXL} 28px`,
    backdropFilter: 'blur(20px)',
  },
  form: { display: 'flex', flexDirection: 'column', gap: tokens.spacingVerticalM },
  input: {
    background: 'rgba(255,255,255,0.08)',
    border: '1px solid rgba(255,255,255,0.12)',
    borderRadius: tokens.borderRadius2XLarge,
    padding: `14px ${tokens.spacingHorizontalL}`,
    color: '#ffffff',
    fontSize: '15px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  },
  error: { fontSize: '13px', color: '#f87171', margin: `${tokens.spacingVerticalXS} 0 0`, textAlign: 'left' },
  submit: {
    background: 'linear-gradient(135deg, #09aa89, #06836a)',
    border: 'none',
    borderRadius: tokens.borderRadius2XLarge,
    padding: '14px',
    color: '#ffffff',
    fontSize: '15px',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: tokens.spacingVerticalXS,
    boxShadow: '0 4px 20px rgba(9,170,137,0.4)',
    fontFamily: 'inherit',
  },
  footer: { marginTop: tokens.spacingVerticalXXXL, fontSize: tokens.fontSizeBase200, color: 'rgba(255,255,255,0.25)' },
});

export default function ComingSoon({ children }) {
  const s = useStyles();
  const { t } = useTranslation();
  const [authed, setAuthed] = useState(() => localStorage.getItem(PREVIEW_KEY) === '1');
  const [user, setUser] = useState('');
  const [pass, setPass] = useState('');
  const [error, setError] = useState('');

  if (authed) return children;

  const handleLogin = (e) => {
    e.preventDefault();
    if (user === PREVIEW_USER && pass === PREVIEW_PASS) {
      localStorage.setItem(PREVIEW_KEY, '1');
      setAuthed(true);
    } else {
      setError(t('coming_soon.error'));
    }
  };

  return (
    <div className={s.page}>
      <div className={s.wrap}>
        {/* Logo / Brand */}
        <div className={s.logo}>
          <h1 className={s.title}>FITIT</h1>
          <p className={s.subtitle}>
            {t('coming_soon.subtitle')}
          </p>
        </div>

        {/* Login card */}
        <div className={s.card}>
          <form onSubmit={handleLogin} className={s.form}>
            <input
              type="text"
              placeholder={t('coming_soon.username_ph')}
              value={user}
              onChange={e => { setUser(e.target.value); setError(''); }}
              autoComplete="username"
              className={s.input}
            />
            <input
              type="password"
              placeholder={t('coming_soon.password_ph')}
              value={pass}
              onChange={e => { setPass(e.target.value); setError(''); }}
              autoComplete="current-password"
              className={s.input}
            />
            {error && (
              <p className={s.error}>{error}</p>
            )}
            <button type="submit" className={s.submit}>
              {t('coming_soon.submit')}
            </button>
          </form>
        </div>

        <p className={s.footer}>
          {t('coming_soon.copyright', { year: new Date().getFullYear() })}
        </p>
      </div>
    </div>
  );
}
